<app-feature-editor title="Scalar Settings" [getItems]="getScalarSettings" (selectedIdChange)="scalarSettingsIdChanged($event)">
  <div *ngIf="hasScalarSettings" class="table">
    <div class="row">
      <div class="label-cell">Color scheme</div>
      <div class="control-cell">
        <select #colorSchemeSelect [value]="colorScheme" (change)="colorSchemeChanged(colorSchemeSelect.value)">
            <option *ngFor="let item of colorSchemes" [value]="item.id">{{item.name}}</option>
          </select>
      </div>
    </div>
    <div class="row">
      <div class="label-cell">Num levels</div>
      <div class="control-cell">
        <app-slider-textbox #levelCountControl [integer]="true" [value]="levelCount" [min]="1" [max]="50" (change)="levelCountChanged(levelCountControl.value)"></app-slider-textbox>
      </div>
    </div>
    <div class="row">
      <div class="label-cell">Min value</div>
      <div class="control-cell">
        <app-slider-textbox #rangeMinControl [value]="rangeMinimum" [min]="minScalarValue" [max]="maxScalarValue" [disabled]="autoScale" (change)="rangeMinimumChanged(rangeMinControl.value)"></app-slider-textbox>
      </div>
    </div>
    <div class="row">
      <div class="label-cell">Max value</div>
      <div class="control-cell">
        <app-slider-textbox #rangeMaxControl [value]="rangeMaximum" [min]="minScalarValue" [max]="maxScalarValue" [disabled]="autoScale" (change)="rangeMaximumChanged(rangeMaxControl.value)"></app-slider-textbox>
      </div>
    </div>
    <div class="row">
      <div class="label-cell">Autoscale</div>
      <div class="control-cell"><input #autoScaleCheckbox type="checkbox" [checked]="autoScale" (change)="autoScaleChanged(autoScaleCheckbox.checked)" /></div>
    </div>
    <div class="row">
      <div class="label-cell">Logarithmic mapping</div>
      <div class="control-cell"><input #logarithmicMappingCheckbox type="checkbox" [checked]="logarithmicMapping" (change)="logarithmicMappingChanged(logarithmicMappingCheckbox.checked)" /></div>
    </div>
    <div class="row">
      <div class="label-cell">Node averaged values</div>
      <div class="control-cell"><input #nodeAveragedValuesCheckbox type="checkbox" [checked]="nodeAveragedValues" (change)="nodeAveragedValuesChanged(nodeAveragedValuesCheckbox.checked)" /></div>
    </div>
  </div>
</app-feature-editor>
